import React from 'react';

import { Grid } from '@crossnokaye/ux-common';

import { IconConfig, IconConfigVariant } from '@repo/sdk/models/components';

import { AnimaticIcon } from '@/features/equipment-browser/animatics/animatic-icon';
import { SubcomponentAttributeConfig } from '@/features/equipment-browser/equipment-details/state/related-devices.state';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/ux-common/components/accordion/accordion';
import { Header, HeaderIcon, HeaderTitle } from '@/ux-common/components/header/header';
import { Typography } from '@/ux-common/components/typography/typography';

import { SubcomponentAttribute } from './subcomponent-attribute';

interface SubcomponentTemplateProps {
  displayName: string;
  icon: IconConfig;
  attributes: SubcomponentAttributeConfig[];
}

export const Subcomponent = ({
  displayName,
  icon,
  attributes,
}: SubcomponentTemplateProps): React.ReactNode => {
  return (
    <Accordion
      key={`accordion-${displayName}`}
      type={'multiple'}
      defaultValue={[`subcomponents-${displayName}`]}
    >
      <AccordionItem value={`subcomponents-${displayName}`}>
        <AccordionTrigger>
          <Header>
            <HeaderIcon>
              <AnimaticIcon
                icon={icon?.icon ?? ''}
                variant={icon?.variant ?? IconConfigVariant.Default}
                size={'sm'}
              />
            </HeaderIcon>
            <HeaderTitle>
              <Typography as="h3" className="text-count-header truncate">
                {displayName}
              </Typography>
            </HeaderTitle>
          </Header>
        </AccordionTrigger>
        <AccordionContent className="pt-thin pb-0">
          <Grid variant="responsive-3" gap="thin">
            {attributes?.map((attribute: SubcomponentAttributeConfig, index: number) => {
              return (
                <SubcomponentAttribute
                  key={`${displayName}--attribute-${index}`.replace(/ /g, '-')}
                  attribute={attribute}
                />
              );
            })}
          </Grid>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
